module.exports = __webpack_public_path__ + "img/qr-app-store.05f2b0de.png";